import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesIT: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        success: {
            verificationOnly: "SheerID si occupa solo della verifica. Ora che sei stato approvato, ti preghiamo di indirizzare tutte le domande sui termini della promozione e/o sull'uso del codice al servizio clienti<a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland</a>.",
        },
        error: {
            redirectButtonText: 'CONTINUARE A TIMBERLAND',
        },
    },
};
